import { render, staticRenderFns } from "./TripCard.vue?vue&type=template&id=e4aaeb48&"
import script from "./TripCard.vue?vue&type=script&lang=js&"
export * from "./TripCard.vue?vue&type=script&lang=js&"
import style0 from "./TripCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports